module.exports = __webpack_public_path__ + "img/responsive hospitium-08.afb98bc6.jpg";